import { Component, OnInit } from '@angular/core';
import { ZtLoaderService } from './zt-loader.service';

@Component({
    selector: 'zt-loader',
    templateUrl: 'zt-loader.component.html',
    styleUrls: ['zt-loader.component.scss'],
})
export class ZtLoaderComponent implements OnInit {
    isLoaderActive: boolean = false;

    constructor(private loadingService: ZtLoaderService) {}

    ngOnInit() {
        this.loadingService.loaderSubject.subscribe((value: boolean) => {
            this.isLoaderActive = value;
        });
    }
}
